module.exports = __webpack_public_path__ + "img/logo.29756046.png";